import { Link } from "react-router-dom";
import { OmGlyph, MandalaMark, OrnamentDivider } from "@/components/VedicOrnaments";

const Footer = () => (
  <footer className="border-t border-[var(--hairline-gold)] bg-cream-soft relative" data-testid="site-footer">
    <div className="max-w-[1500px] mx-auto px-6 md:px-14 py-20 md:py-28">
      <OrnamentDivider className="mb-16" />

      <div className="grid md:grid-cols-4 gap-12 md:gap-16">
        <div className="md:col-span-2">
          <div className="flex items-baseline gap-3 mb-6">
            <OmGlyph size={24} />
            <span className="font-display text-3xl text-terracotta italic" style={{ fontWeight: 500 }}>Bhrigu</span>
          </div>
          <p className="font-display text-2xl text-ink leading-snug max-w-md" style={{ fontWeight: 400 }}>
            Jyotisha for the <span className="font-display-italic text-terracotta">curious</span> modern soul.
          </p>
          <p className="text-ink-soft text-sm leading-relaxed mt-4 max-w-md">
            Real kundalis. Navagraha. Nakshatras. Conversational AI that speaks the old language in your own words.
          </p>
        </div>
        <div>
          <div className="section-label mb-6">Product</div>
          <ul className="space-y-3 text-sm text-ink">
            <li><Link to="/features" className="link-underline">The Tradition</Link></li>
            <li><Link to="/pricing" className="link-underline">Pricing</Link></li>
            <li><Link to="/app" className="link-underline">Dashboard</Link></li>
          </ul>
        </div>
        <div>
          <div className="section-label mb-6">Company</div>
          <ul className="space-y-3 text-sm text-ink">
            <li><Link to="/about" className="link-underline">About</Link></li>
            <li><Link to="/faq" className="link-underline">FAQ</Link></li>
            <li><Link to="/contact" className="link-underline" data-testid="footer-contact">Contact & Support</Link></li>
            <li><Link to="/privacy" className="link-underline" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/delete-account" className="link-underline" data-testid="footer-delete-account">Delete Account</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-20 pt-10 border-t border-[var(--hairline)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[10px] text-ink-muted uppercase tracking-[0.3em] font-mono">
        <span>© {new Date().getFullYear()} Bhrigu · सर्वाधिकार सुरक्षित · in the lineage of Maharishi Bhrigu</span>
        <span className="opacity-70">Entertainment & reflective guidance · Not a substitute for professional counsel</span>
      </div>
    </div>
  </footer>
);

export default Footer;
